module.exports = __webpack_public_path__ + "img/me1.6c8a331e.jpg";